import * as DateFormatter from "../../../utils/DateFormatter";
import {ResponsiveSize} from "../../../utils/ResponsiveHelper";

export default class CardBatch {
  constructor(jsonResponse) {

    this.id = jsonResponse["id"];
    this.batchSize = jsonResponse["batch-size"];
    this.creatingUserId = jsonResponse["creating-user-id"];
    this.dateCreated = jsonResponse["date-created"];
    this.dateCreatedFormatted = DateFormatter.prettifyDate(jsonResponse["date-created"]);
    this.assigned = jsonResponse["assigned"];
    this.creatingUsername = jsonResponse["creating-username"];
    this.numberOfCardsAssignedToAgents = jsonResponse["number-of-cards-assigned-to-agents"];
    this.numberOfCardsAssignedToCustomers = jsonResponse["number-of-cards-assigned-to-customers"];
    this.assignedUserId = jsonResponse["assigned-user-id"];
    this.assignedUsername = jsonResponse["assigned-username"];
  }

static getColumnConfig = function (){
    return [
      {
        dataField: "id",
        header: "Id",
        width: "50px",
      },
      {
        dataField: "dateCreatedFormatted",
        header: "Date Created"
      },
      {
        dataField: "batchSize",
        header: "Size",
        width: "50px"
      },
      {
        dataField: "numberOfCardsAssignedToAgents",
        header: "Number Of Cards AssignedTo Agents",
        hidden :ResponsiveSize.LG
      },
      {
        dataField: "numberOfCardsAssignedToCustomers",
        header: "Number Of Cards AssignedTo Customers",
        hidden :ResponsiveSize.XL
      }
    ];
  };
}
